import React from 'react';
import { CheckCircleIcon, HeartIcon, ShieldIcon, SparklesIcon } from 'lucide-react';
export function BabyBenefitsSection() {
  const benefits = [{
    icon: CheckCircleIcon,
    title: 'Saber qué hacer cada día',
    description: 'Sin pensar de más'
  }, {
    icon: ShieldIcon,
    title: 'Sentirte segura',
    description: 'Al cambiar de textura'
  }, {
    icon: SparklesIcon,
    title: 'Cocinar en menos tiempo',
    description: 'Con batch cooking'
  }, {
    icon: HeartIcon,
    title: 'Darle comida casera',
    description: 'Sana y local'
  }];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light to-white" data-id="element-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-31">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-32">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-33">
            Lo Que Vas a Lograr
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-34">
            Con este ebook vas a:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 stagger-children" data-id="element-35">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-blue-light/50 shadow-baby-soft hover:shadow-baby-glow transition-all text-center" data-id="element-36">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-37">
                  <Icon className="w-7 h-7 sm:w-8 sm:h-8 text-white" data-id="element-38" />
                </div>
                <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-39">
                  {benefit.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600" data-id="element-40">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>

        <div className="bg-baby-gradient-blue p-6 sm:p-8 rounded-baby-lg text-center shadow-baby-glow animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-41">
          <p className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-42">
            Evitar procesados y recetas improvisadas
          </p>
          <p className="text-base sm:text-lg md:text-xl text-white/95 font-medium" data-id="element-43">
            En palabras simples: Menos "no sé qué hacer". Más "esto ya está
            resuelto".
          </p>
        </div>
      </div>
    </section>;
}